/* Functions for the top-info-bar */

jQuery( function( $ ) {
	$( '.info-bar-additional-btn' ).on( 'click', function( e ) {
		e.preventDefault();
		$( '.info-bar' ).toggleClass( 'expanded' );
	} );
} );
